import { Component, Input } from '@angular/core';

@Component({
  selector: 'layout-payment',
  templateUrl: './payment.component.html',
  styleUrls: ['./payment.component.scss']
})
export class PaymentComponent {
  @Input() status: 'success' | 'pending' | 'disabled';
  @Input() count!: number;
  @Input() total!: number;
  @Input() amount: string;
  @Input() interestPercent: string;
  @Input() date: string;

}
